import Image from "next/image";

type Tone = "light" | "dark" | "mid" | "bright" | "macro";

interface PhotoFrameProps {
  src?: string;
  alt?: string;
  tone?: Tone;
  ratio?: string;
  label?: string;
  corner?: string;
  priority?: boolean;
  sizes?: string;
  fit?: "cover" | "contain";
  className?: string;
  children?: React.ReactNode;
}

export default function PhotoFrame({
  src,
  alt = "",
  tone = "light",
  ratio = "4/5",
  label,
  corner,
  priority,
  sizes = "(max-width:768px) 100vw, 50vw",
  fit = "cover",
  className = "",
  children,
}: PhotoFrameProps) {
  return (
    <div
      className={`bp-ph ${className}`}
      data-tone={tone}
      style={{ aspectRatio: ratio, width: "100%" }}
    >
      {src && (
        <Image
          src={src}
          alt={alt}
          fill
          priority={priority}
          sizes={sizes}
          style={{ objectFit: fit, zIndex: 1 }}
        />
      )}
      {corner && <span className="bp-ph-corner" style={{ zIndex: 3 }}>{corner}</span>}
      {label && <span className="bp-ph-label" style={{ zIndex: 3 }}>{label}</span>}
      {children}
    </div>
  );
}
